import { motion } from "framer-motion";
import {
  Mail,
  MailOpen,
  Paperclip,
  CheckCircle,
  AlertCircle,
  Star,
  ArrowUpRight,
  Trash2,
} from "lucide-react";

const EmailListItem = ({
  email,
  selectedFlags,
  activeFolder,
  onEmailSelect,
  updateFlag,
  deleteEmail,
  formatDate,
  getFlagColor,
  getFlagIcon,
}) => {
  const isUnread = !email.is_read;
  const activeFlag = selectedFlags[email.id];

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={() => onEmailSelect(email)}
      className={`
        group relative px-4 py-3 cursor-pointer border-b
        transition-colors
        ${
          isUnread
            ? "bg-blue-50/30 dark:bg-blue-900/10"
            : "bg-white dark:bg-slate-900"
        }
        hover:bg-slate-50 dark:hover:bg-slate-800
      `}
    >
      {/* Top Row */}
      <div className="flex items-center gap-4">
        {/* Icon */}
        <div
          className={`flex items-center justify-center w-9 h-9 rounded-full
            ${isUnread ? "bg-[#0072FF]/10" : "bg-slate-200 dark:bg-slate-700"}
          `}
        >
          {isUnread ? (
            <Mail className="w-4 h-4 text-[#0072FF]" />
          ) : (
            <MailOpen className="w-4 h-4 text-slate-400" />
          )}
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p
              className={`text-sm truncate ${
                isUnread
                  ? "font-semibold text-slate-900 dark:text-white"
                  : "text-slate-700 dark:text-slate-300"
              }`}
            >
              {email.from_name || email.from_email}
            </p>

            <span className="text-slate-400">—</span>

            <p
              className={`text-sm truncate ${
                isUnread
                  ? "text-slate-900 dark:text-white"
                  : "text-slate-600 dark:text-slate-400"
              }`}
            >
              {email.subject}
            </p>
          </div>

          <div className="mt-1 flex items-center gap-2 text-xs text-slate-500">
            {email.has_attachments && <Paperclip className="w-3.5 h-3.5" />}
            <span>{email.from_email}</span>
          </div>
          {activeFlag && (
        <div
          className="mt-1 opacity-1 translate-y-1
                     group-hover:opacity-100 group-hover:translate-y-0
                     transition-all duration-200"
        >
          <span
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs border
              ${getFlagColor(activeFlag)}`}
          >
            {getFlagIcon(activeFlag)}
            {activeFlag}
          </span>
        </div>
      )}
        </div>

        {/* Right: Date + Actions */}
        <div className="flex items-center gap-3">
          <span className="text-xs text-slate-500 whitespace-nowrap">
            {formatDate(email.date)}
          </span>

          {/* Hover Actions */}
          <div
            className="flex items-center gap-1
                        
                       transition-all duration-200"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => updateFlag(email.id, "Done")}
              className="p-1.5 rounded hover:bg-green-100 dark:hover:bg-green-900/20"
            >
              <CheckCircle className="w-4 h-4 text-green-600" />
            </button>

            <button
              onClick={() => updateFlag(email.id, "Exception")}
              className="p-1.5 rounded hover:bg-red-100 dark:hover:bg-red-900/20"
            >
              <AlertCircle className="w-4 h-4 text-red-600" />
            </button>

            <button
              onClick={() => updateFlag(email.id, "Important")}
              className="p-1.5 rounded hover:bg-yellow-100 dark:hover:bg-yellow-900/20"
            >
              <Star className="w-4 h-4 text-yellow-600" />
            </button>

            <button
              onClick={() => updateFlag(email.id, "Follow-up")}
              className="p-1.5 rounded hover:bg-blue-100 dark:hover:bg-blue-900/20"
            >
              <ArrowUpRight className="w-4 h-4 text-blue-600" />
            </button>

            <button
              onClick={() => deleteEmail(email.id, activeFolder === "trash")}
              className="p-1.5 rounded hover:bg-red-100 dark:hover:bg-red-900/20"
            >
              <Trash2 className="w-4 h-4 text-red-600" />
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Marker (hover only) */}
      {/* {activeFlag && (
        <div
          className="mt-2 ml-14 opacity-1 translate-y-1
                     group-hover:opacity-100 group-hover:translate-y-0
                     transition-all duration-200"
        >
          <span
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs border
              ${getFlagColor(activeFlag)}`}
          >
            {getFlagIcon(activeFlag)}
            {activeFlag}
          </span>
        </div>
      )} */}
    </motion.div>
  );
};

export default EmailListItem;

// {<motion.div
//                             key={email.id}
//                             initial={{ opacity: 0, y: 20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             className={`p-4 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors cursor-pointer ${!email.is_read ? 'bg-blue-50/30 dark:bg-blue-900/10' : ''
//                                 }`}
//                             onClick={() => onEmailSelect(email)}
//                         >
//                             <div className="flex items-start space-x-4">
//                                 {/* Read/Unread Icon */}
//                                 <div className="mt-1">
//                                     {email.is_read ? (
//                                         <MailOpen className="w-5 h-5 text-slate-400" />
//                                     ) : (
//                                         <Mail className="w-5 h-5 text-[#0072FF]" />
//                                     )}
//                                 </div>

//                                 {/* Email Content */}
//                                 <div className="flex-1 min-w-0">
//                                     <div className="flex items-start justify-between mb-1">
//                                         <div className="flex-1 min-w-0">
//                                             <p className={`text-sm font-semibold truncate ${!email.is_read
//                                                 ? 'text-slate-900 dark:text-white'
//                                                 : 'text-slate-700 dark:text-slate-300'
//                                                 }`}>
//                                                 {email.from_name || email.from_email}
//                                             </p>
//                                             <p className="text-xs text-slate-500 dark:text-slate-500 truncate">
//                                                 {email.from_email}
//                                             </p>
//                                         </div>
//                                         <div className="flex items-center space-x-2 ml-2">
//                                             {email.has_attachments && (
//                                                 <Paperclip className="w-4 h-4 text-slate-400" />
//                                             )}
//                                             <span className="text-xs text-slate-500 dark:text-slate-500 whitespace-nowrap">
//                                                 {formatDate(email.date)}
//                                             </span>
//                                         </div>
//                                     </div>

//                                     <p className={`text-sm mb-2 truncate ${!email.is_read
//                                         ? 'text-slate-900 dark:text-white font-medium'
//                                         : 'text-slate-600 dark:text-slate-400'
//                                         }`}>
//                                         {email.subject}
//                                     </p>

//                                     {/* Flags */}
//                                     <div className="flex items-center justify-between">
//                                         <div className="flex items-center space-x-2">
//                                             {selectedFlags[email.id] && (
//                                                 <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-md text-xs border ${getFlagColor(selectedFlags[email.id])
//                                                     }`}>
//                                                     {getFlagIcon(selectedFlags[email.id])}
//                                                     <span>{selectedFlags[email.id]}</span>
//                                                 </span>
//                                             )}

//                                             {/* Flag Buttons */}
//                                             <div className="flex space-x-1" onClick={(e) => e.stopPropagation()}>
//                                                 <button
//                                                     onClick={() => updateFlag(email.id, 'Done')}
//                                                     className="p-1 hover:bg-green-100 dark:hover:bg-green-900/20 rounded transition-colors"
//                                                     title="Mark as Done"
//                                                 >
//                                                     <CheckCircle className="w-3.5 h-3.5 text-green-600" />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => updateFlag(email.id, 'Exception')}
//                                                     className="p-1 hover:bg-red-100 dark:hover:bg-red-900/20 rounded transition-colors"
//                                                     title="Mark as Exception"
//                                                 >
//                                                     <AlertCircle className="w-3.5 h-3.5 text-red-600" />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => updateFlag(email.id, 'Important')}
//                                                     className="p-1 hover:bg-yellow-100 dark:hover:bg-yellow-900/20 rounded transition-colors"
//                                                     title="Mark as Important"
//                                                 >
//                                                     <Star className="w-3.5 h-3.5 text-yellow-600" />
//                                                 </button>
//                                                 <button
//                                                     onClick={() => updateFlag(email.id, 'Follow-up')}
//                                                     className="p-1 hover:bg-blue-100 dark:hover:bg-blue-900/20 rounded transition-colors"
//                                                     title="Mark for Follow-up"
//                                                 >
//                                                     <ArrowUpRight className="w-3.5 h-3.5 text-blue-600" />
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         {/* Delete Button */}
//                                         <button
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 if (activeFolder === 'trash') {
//                                                     if (window.confirm('Permanently delete this email? This cannot be undone.')) {
//                                                         deleteEmail(email.id, true);
//                                                     }
//                                                 } else {
//                                                     deleteEmail(email.id, false);
//                                                 }
//                                             }}
//                                             className="p-1.5 hover:bg-red-100 dark:hover:bg-red-900/20 rounded transition-colors"
//                                             title={activeFolder === 'trash' ? 'Delete Permanently' : 'Move to Trash'}
//                                         >
//                                             <Trash2 className="w-4 h-4 text-red-600" />
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </motion.div>}
